import { render } from "./modifyuserprimaryinfo.vue?vue&type=template&id=c5a3a75a"
import script from "./modifyuserprimaryinfo.vue?vue&type=script&lang=js"
export * from "./modifyuserprimaryinfo.vue?vue&type=script&lang=js"

import "./modifyuserprimaryinfo.vue?vue&type=style&index=0&id=c5a3a75a&lang=less"

import exportComponent from "F:\\ffile\\vscodeprj\\app\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__